export const EXPERIMENT = {
  key: "locations-section-v1",
  name: "Locations Section Visibility Test",
  groups: ["A", "B"],
};

export const assignExperimentGroup = (sessionId = "abc123") => {
  if (!sessionId) {console.log("sessionId is required.")}

  const cleanId = sessionId?.replace(/-/g, "");
  const hashPortion = cleanId?.slice(0, 8); // Using a wider slice for better randomness
  const numericValue = parseInt(hashPortion, 16);
  const groupIndex = numericValue % EXPERIMENT.groups.length;
  const group = EXPERIMENT.groups[groupIndex];

  return group;
};
